import AnalyticsEvent from './analytics-event';
import { Wishlist } from './segment-ecommerce-types';

export class ProductWishlistOrderChangedEvent extends AnalyticsEvent {
  public readonly name = 'Product Wishlist Order Changed';

  constructor(public readonly properties: Wishlist) {
    super();
  }
}
